<template>
  <div>
    <el-col :span="24" style="height:100%;">
      <div style="height:100%;padding:5px;">
        <el-row style="text-align:center">
          <img src="../../assets/logo-transparent.png" style="height: 150px; width: auto; object-fit: contain; float:both;">
        </el-row>
        <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
          <b>
            Результаты тестирования
          </b>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12" style="text-align:right;">
            <el-row>
                Испытуемый:
            </el-row>
            <el-row>
                Сценарий:
            </el-row>
            <el-row>
                Закончен:
            </el-row>
            <el-row>
                Затрачено времени:
            </el-row>
          </el-col>
          <el-col :span="12" style="text-align:left;">
            <el-row>
                <b>{{ scenarioResultUser }}</b>
            </el-row>
            <el-row>
                <b>{{ scenarioResultLabel }}</b>
            </el-row>
            <el-row>
                <b>{{ finishDate }}</b>
            </el-row>
            <el-row>
                <b>{{ timeElapsed }}</b>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
          <b>
            Сводная информация по тестам
          </b>
        </el-row>
        <el-row :gutter="10" style="padding: 0px 5px 0px 5px;">
          <el-table
            :data="tests"
            border
            show-summary
            :summary-method="getSummaries"
            v-bind:height="testsTableHeight"
            style="width:1000px; margin:auto;">
            <el-table-column
              prop="label"
              label="Тест"
              width="330"
              class="grid-text-overflow">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.label }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="correct"
              label="Верно">
            </el-table-column>
            <el-table-column
              prop="wrong"
              label="Не верно">
            </el-table-column>
            <el-table-column
              prop="skipped"
              label="Пропущено">
            </el-table-column>
            <el-table-column
              prop="total"
              label="Всего">
            </el-table-column>
            <el-table-column
              prop="percentage"
              label="Процент">
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </el-col>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import time from '../../api/contest/time'
  import grid from '../../api/helpers/grid'
  import { mapGetters, mapActions } from 'vuex'

  export default {
      name: 'report',
      data() {
      return {
        tests: [

        ],
        testsHeight: null
      }
    },
    computed: {
      testsTableHeight: function() {
        if(!this.testsHeight) {
          let height = this.getParentClientHeight();
          if(height)
            return height - (150 + 24 * 2 + 23 * 4 + 65 + 10);
        }
        return this.testsHeight;
      },
      finishDate: function() {
        return grid.formatDate(this.scenarioDateFinished);
      },
      timeElapsed: function() {
        return time.formatMinutes(this.scenarioTimeElapsed);
      },
      ...mapGetters([
        'scenarioLabel',
        'scenarioUser',
        'elapsedTime',
        'isContestAuthorized',
        'scenarioResults',
        'scenarioResultUser',
        'scenarioResultLabel',
        'scenarioResultTotal',
        'scenarioDateFinished',
        'scenarioTimeElapsed'
      ])
    },
    methods: {
      fetchData: function() {
        this.tests = this.scenarioResults;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        let total = this.scenarioResultTotal;
        if(total) {
          sums[0] = total.label;
          sums[1] = total.correct;
          sums[2] = total.wrong;
          sums[3] = total.skipped;
          sums[4] = total.total;
          sums[5] = total.percentage;
        }

        return sums;
      },
      getParentClientHeight() {
        let element = document.getElementById('content-container');
        if(element) {
          let clientHeight = element.clientHeight;
          if(clientHeight)
            return clientHeight;
        }
        return null;
      },
      resize() {
        let height = this.getParentClientHeight();
        if(height)
          this.testsHeight = height - (150 + 24 * 2 + 23 * 4 + 65 + 10);
        else
          this.testsHeight = null;
      }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resize);
    },
    created: function () {
      window.addEventListener('resize', this.resize);
      if(!this.isContestAuthorized)
        this.$router.push(config.WELCOME_URL);
      else
        this.fetchData();
    }
  }
</script>

<style scoped>
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-text-overflow {
    /*overflow:hidden;
    display:inline-block;*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style>
  
</style>



// WEBPACK FOOTER //
// src/components/contest/report.vue